import * as React from "react";
import { HTTPService } from "../../common/services/httpService";
import { IAPIResponse, IHTTPResponse } from "../../common/models/httpModels";
import { CommonConstants } from "../../common/constants/common-constants";
import { ISchoolModel } from "../models/ISchoolModel";
import { IDeleteSchoolUserRequest } from "./facilitatorSchoolModel";


const httpService = new HTTPService();

const Create = (request: ISchoolModel): Promise<IHTTPResponse<IAPIResponse<any>>> => {
  const url = `${CommonConstants.BaseAddress}${
    CommonConstants.ApiConstants.CreateSchool
  }`;
  return httpService.post(url,request);
};

const Update = (request: ISchoolModel): Promise<IHTTPResponse<IAPIResponse<any>>> => {
  const url = `${CommonConstants.BaseAddress}${
    CommonConstants.ApiConstants.UpdateSchool
  }`;
  return httpService.post(url,request);
};

const DeleteMultiple = (request: IDeleteSchoolUserRequest[]): Promise<IHTTPResponse<IAPIResponse<any>>> => {
  const url = `${CommonConstants.BaseAddress}${
    CommonConstants.ApiConstants.DeleteMultipleSchools
  }`;
  return httpService.post(url,request);
};

const Get = (schoolId:number) :Promise<IHTTPResponse<IAPIResponse<any>>> => {
  const url = `${CommonConstants.BaseAddress}${
    CommonConstants.ApiConstants.GetSchool+'/'+schoolId
  }`;
  return httpService.get(url);
};

const FacilitatorSchoolService = {
    Create,
    Get,
    Update,
    DeleteMultiple
};

export default FacilitatorSchoolService;